import React, { useEffect, useState, useRef } from 'react';
import './Map.css';
import Mapir from 'mapir-react-component';
import { search } from '../../Component/Map/API';
import { errorToast } from '../../Toast/Toast';

const Map = Mapir.setToken({
  transformRequest: url => {
    return { 
      url: url,
      headers: { 
        'x-api-key': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA',
        'Mapir-SDK': 'reactjs'
      }
    };
  }
});
export default function MapHandler(props) {
  const [text, setText] = useState('');
  const [addressState, setAddressState] = useState('');
  const [polygon, setPolygon] = useState();
  const [zoom, setZoom] = useState(13);
  const [lon, setLon] = useState(null);
  const [lat, setLat] = useState(null);
  const [$select, set$select] = useState('poi,city,roads,neighborhood');
  const [$filter, set$filter] = useState('province eq بهشهر');
  const [results, setResults] = useState([]);
  const [showSearch, setShowSearch] = useState(true);
  const [center, setCenter] = useState([53.54347,36.69056]);
  const [nearby, setNearby] = useState({
    active: false,
    coordinates: null
  });
  const drawControl = useRef();

  useEffect(() => {
    if (text.length > 1) {
      const params = {};
      const options = { text, polygon, lon, lat, $select, $filter };
      for (let key in options) {
        if (options[key] !== null && options[key] !== '') {
          params[key] = options[key];
        }
      }
      search(params)
        .then(data => data.json())
        .then(data => {
          if (data['odata.count'] > 0) {
            setResults(data.value);
          } else {
            setResults([{ notFound: true }]);
          }
        });
    } else if (text.length === 0) {
      setResults([]);
    }
    setText(props.text)
    setPolygon(props.polygon)
    setCenter(props.center)
    if(text===''){
      setShowSearch(true)
    }
  }, [text, $select, $filter, nearby.coordinates,props.text,lat,lon,polygon,props.polygon,props.center]);

  function mapClickHandler(map, e) {
    setCenter([e.lngLat.lng, e.lngLat.lat])
    setTimeout(() => {
      setZoom(15)
    }, 1000);
    localStorage.setItem("checkMarker",true)
    reverseFunction(map, e)
    if (nearby.active) {
      setNearby({
        ...nearby,
        coordinates: [e.lngLat.lng, e.lngLat.lat]
      });
      setLon(e.lngLat.lng);
      setLat(e.lngLat.lat);
      let s = $select;
      if (!$select.includes('nearby')) {
        let sa = $select.split(',');
        sa.push('nearby');
        s = sa.filter(item => item !== '').join(',');
      }
      set$select(s);
    }
  }

  useEffect(() => {
    if (polygon === '') {
      drawControl.current.draw.changeMode('draw_polygon');
    } else if (polygon instanceof Object) {
      set$filter('polygon eq true');
    } else if (polygon === null) {
      set$filter('');
    }
  }, [polygon]);

  const [markerArray, setMarkerArray] = useState([])

  function reverseFunction(map, e) {
    var url = `https://map.ir/reverse/no?lat=${e.lngLat.lat}&lon=${
      e.lngLat.lng
    }`;
    fetch(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": 'eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1In0.eyJhdWQiOiIxNTE2OCIsImp0aSI6ImE1ODNiNzIzMWNjNTcxNzg4OGI2NzZkODI1NjNjM2RjNGQyNDJlMGVlZmQ3ZDcyZmYxYTZmN2E5ZDhjNmI3YTNhOWIxOTE1ZTdkOTQ5MDE1IiwiaWF0IjoxNjg3NjA2MzI2LCJuYmYiOjE2ODc2MDYzMjYsImV4cCI6MTY4OTA3NTEyNiwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.oSSkLtV_ZrBPiOLVVRjgAdbmtIKaA03H4zigvRXvnePLmkPd1oBQA4M4k4a68-JB3HtQmcOiXGSB0g_btjL6eArzq6f5g6tjAi0Hr7UV_AyCZXNDEcD1-ZnswznydpHsAiVNtmHD81PloLw6OV_WfQLqZXkE__jVttwk6Pi_8i7G6xEuenJ5GQxxwsyIBxdGvdXu-S85M0ULxcCWaaq1q-fKL9LfqyzxUz-whl_4SgqQHbxrypvuZ3Gi8zv9TYVy0GQx55Rw0rGXnxouQc-xAuWZFMJZ8xMxTPj-Nj4EYoanBvl4oKAqHANbMi-hZq9G-MBlI6bfLE05uN37XAInCA'
      }
    })
      .then(response => response.json())
      .then(data => {
      localStorage.setItem('lon',data.geom.coordinates[0])
      localStorage.setItem('lat',data.geom.coordinates[1]) 
      localStorage.setItem('address_compact',data.address_compact)
      });
    const array = [];
    array.push(
      <Mapir.Marker
        coordinates={[e.lngLat.lng, e.lngLat.lat]}
        // anchor="bottom"
        Image={"/Assets/Images/map/marker1.png"}
        key={0}
        />
        );
    // setCenter([e.lngLat.lng, e.lngLat.lat])
    // setZoom(16)
    setMarkerArray(array);

  }
    ////////////////click search result ///////////////
    useEffect(()=>{
      
    },[props.getTextDataState])
    function searchOnclick(item){
      const array = [];
      array.push(
        <Mapir.Marker
        coordinates={[item.geom.coordinates[0] ,item.geom.coordinates[1]]}
        Image={"/Assets/Images/map/marker1.png"}
        key={0}
        />
        );
      
        setMarkerArray(array);
        setCenter([item.geom.coordinates[0] ,item.geom.coordinates[1]]);
        setAddressState(item.address)
        setShowSearch(false)
 
    }
    const handleCurrentLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setCenter([longitude, latitude]);
            const array = [];
            array.push(
              <Mapir.Marker
                coordinates={[longitude, latitude]}
                Image={"/Assets/Images/map/marker1.png"}
                key={1}
              />
            );
            setMarkerArray(array);
    
            // Add a slight delay to ensure the map updates the center before applying zoom
            setTimeout(() => {
              setZoom(15); // Zoom in on the user's location
            }, 1500);
          },
          (error) => {
            console.error("Error fetching location:", error);
            alert("در مکان یابی شما مشکلی پیش آمده!");
          }
        );
      } else {
        errorToast("مرورگر شما این قابلیت را پشتیبانی نمی کند!");
      }
    };
  return (
    <>
      <div className="App">
        <Mapir
          onClick={(map, e) => mapClickHandler(map, e)}
          center={center}
          zoom={[zoom]}
          Map={Map}
          userLocation
        >
          {markerArray}
        </Mapir>
      </div>
      <button
          className="current-location-btn"
          onClick={handleCurrentLocation}
        >
          📍
        </button>
      {showSearch? 
      <div className="container search-box bg-transparent">
        <div className="container search-box__item" style={{display:'none'}}>
          <input
            autoComplete="off"
            type="text"
            id="search"
            placeholder="دنبال کجا می&zwnj;گردید..."
            onChange={e => setText(e.target.value)}
            value={text}
          />
        </div>
        {results.length > 0 && (
          <div className="container search-box__item search-results">
            {results.map((item,index) => {
              if (item.notFound === true) {
                return <p>نتیجه ای یافت نشد</p>;
              } else {
                return (
                  <div
                    key={index}
                    onClick={()=>searchOnclick(item)}
                    className="search-result-item"
                  >
                    <p className="search-result-item-title">
                      {item.title}
                    </p>
                    <p className="search-result-item-address">{item.address}</p>
                  </div>
                );
              }
            })}
          </div>
        )}
      </div>
      
      : 
      null
      }
    </>
  );
}